import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { MdSearch, MdClose } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa";
import Divider from "@mui/material/Divider";
import useHttp from "hooks/use-http";
import NotFound from "components/shared/NotFound/NotFound";
import { GetAllProductsSearchRequest } from "api/requests";
import spliter from "helper/digit-spliter";
import Grid from "@mui/material/Grid";
import notfound from "assets/img/notfound.png";
import { IMG_BASE_URL } from "constants";
import {
  SearchBoxWrapper,
  StyledInputBase,
  StyledSearch,
  SearchBox,
  StyledProductBox,
  StyledProductDiv,
  StyledProductImg,
  StyledProductImgDiv,
  StyledProductTitle,
  StyledProductPrice,
  StyledSlideProductDiscount,
  StyledProductBeforePrice,
  StyledColorsProduct,
  StyledProductData,
} from "./Search.style";

export default function Search(props) {
  const params = useParams();
  const navigate = useNavigate();
  const { request } = useHttp();
  const [productData, setProductData] = useState({
    data: [],
    count: 0,
  });
  const [state, setState] = useState({
    value: params.searchText ? params.searchText : "",
  });

  const handleChange = (e) => {
    // setProductData({
    //   data: [],
    //   count: 0,
    // });
    setState({ value: e.target.value });
    getProducts();
  };

  const submit = (event) => {
    setState({ value: event.target.value });
    navigate("/products/search=" + state.value);
    setState({ value: params.searchText });
  };

  //////////////// Get All Products  ////////////////
  const getProducts = useCallback(async () => {
    const res = await request({
      url: GetAllProductsSearchRequest,
      values: {
        search: state.value,
      },
    });

    if (res) {
      if (res.count < 1) {
        return setProductData({
          count: res.count,
          data: [{ content: "هیچ محصولی یافت نشد" }],
        });
      }

      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items.title,
        price: items.price,
        image: items.image,
        design_id: items.design_id,
        discount_percent: items.discount_percent,
        before_discount_price: items.before_discount_price,
        colors: items.colors,
      }));

      setProductData({
        data: transformedData,
        count: res.count,
      });
    }
  }, [request, state.value]);

  useEffect(() => {
    if (state.value.length != 0 && state.value != "") {
      getProducts();
    }
  }, [getProducts, state.value]);

  return (
    <SearchBox>
      <StyledSearch>
        {state.value.length == 0 && state.value == "" ? (
          ""
        ) : (
          <SearchBoxWrapper>
            <IconButton
              aria-label="close"
              sx={{ color: "#009AC2" }}
              onClick={() => {
                setProductData({
                  count: 0,
                  data: "",
                });
                setState({ value: "" });
              }}
            >
              <MdClose size={20} />
            </IconButton>

            <Divider orientation="vertical" variant="middle" flexItem light />

            <IconButton
              aria-label="search"
              sx={{ color: "#009AC2" }}
              onClick={(event) => submit(event)}
            >
              <MdSearch size={20} onClick={props.Close} />
            </IconButton>
          </SearchBoxWrapper>
        )}
        <StyledInputBase
          placeholder="جستجو"
          inputProps={{ "aria-label": "search" }}
          type="text"
          value={state.value}
          onChange={(e) => handleChange(e)}
        />
        <SearchBoxWrapper>
          <IconButton
            aria-label="close"
            sx={{ color: "#009AC2" }}
            onClick={props.Close}
          >
            <FaArrowRight size={20} />
          </IconButton>
        </SearchBoxWrapper>
      </StyledSearch>
      <StyledProductBox>
        <Grid container spacing={{ xs: 2, md: 2 }}>
          {productData.count < 1 || state.value.length == 0
            ? ""
            : productData.data.map((product, index) => (
                <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={index}>
                  <Link
                    to={`/product/${product.id}/search=${state.value}`}
                    key={"product" + index}
                    onClick={props.Close}
                  >
                    <StyledProductDiv elevation={3}>
                      <StyledProductData>
                        <StyledProductImgDiv>
                          {product.image ? (
                            <StyledProductImg
                              src={IMG_BASE_URL + product.image}
                            />
                          ) : (
                            <StyledProductImg src={notfound} />
                          )}
                        </StyledProductImgDiv>
                        <StyledProductTitle>{product.title}</StyledProductTitle>

                        <StyledProductPrice>
                          {spliter(product.price)} تومان
                        </StyledProductPrice>
                      </StyledProductData>
                      <StyledColorsProduct>
                        {product.colors?.map((color, index) => (
                          <span
                            key={"color" + index}
                            style={{ background: color.color_code }}
                          ></span>
                        ))}
                      </StyledColorsProduct>
                    </StyledProductDiv>
                  </Link>
                </Grid>
              ))}
        </Grid>
      </StyledProductBox>
    </SearchBox>
  );
}
